import { CreateRelatedClientBodyAgeCategoryType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import { MAX_CLIENT_AGE_YEARS, getMinBirthDate } from "Infrastructure/Utils/ClientUtils";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, date, object, string } from "yup";

export type FamilyMemberFormModel = {
  readonly firstName: string;
  readonly lastName: string;
  readonly birthDate?: Date;
  readonly ageCategoryType: string;
};

const getYesterday = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return d;
};

export const familyMemberFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<FamilyMemberFormModel> = (t) => {
  return object({
    firstName: string().required("Jméno je povinné"),
    lastName: string().required("Příjmení je povinné"),
    birthDate: date()
      .typeError(t(Resources.Validation.BadValue))
      .when("ageCategoryType", (ageCategoryType: CreateRelatedClientBodyAgeCategoryType[], schema) => {
        if (ageCategoryType?.[0] === CreateRelatedClientBodyAgeCategoryType.plannedChild) {
          return schema.notRequired().nullable();
        }

        return schema
          .required(t(Resources.Validation.Required))
          .min(getMinBirthDate(), t(Resources.Validation.BirthDateTooOld, { years: MAX_CLIENT_AGE_YEARS }))
          .max(getYesterday(), t(Resources.Validation.MustBeOlderThanOneDay));
      }),
    ageCategoryType: string().required(),
  }).defined();
};
